import classNames from "classnames";
import { useHorizontalAutoOverflowScrollContainerGradients } from "util/useAutoOverflowScrollContainerGradients";
import times from "util/times";
import { forwardRef } from "react";

interface Props {
  count: number;
  render: (index: number) => React.ReactNode;
  renderHead?: (props: { className: string }) => React.ReactNode;
  itemWidthClassName?: string;
  itemMarginRightClassName?: string;
  containerClassName?: string;
  innerContainerPaddingClassName?: string;
}

export default forwardRef<HTMLDivElement, Props>(function HorizontalScroller(
  {
    count,
    render,
    renderHead,
    itemWidthClassName = "w-80",
    itemMarginRightClassName = "mr-2",
    containerClassName,
    innerContainerPaddingClassName = "pb-6",
  },
  ref
) {
  const { gradients, leftSensor, rightSensor, scrollContainerRef } =
    useHorizontalAutoOverflowScrollContainerGradients<HTMLDivElement>();

  return (
    <div
      className={classNames("relative", containerClassName)}
      ref={scrollContainerRef}
    >
      <div
        ref={ref}
        className={classNames(
          "overflow-auto overscroll-x-none",
          innerContainerPaddingClassName
        )}
      >
        <ul className={"text-white whitespace-nowrap flex"}>
          {leftSensor}

          {renderHead?.({
            className: classNames("inline-block", itemMarginRightClassName),
          })}

          {times(count, (i) => (
            <div
              key={i}
              className={classNames(
                "inline-block flex-shrink-0",
                itemWidthClassName,
                itemMarginRightClassName
              )}
            >
              {render(i)}
            </div>
          ))}

          {rightSensor}

          <div className="min-w-20 w-10 shrink-0" />
        </ul>
      </div>

      {gradients}
    </div>
  );
});
